import { useEffect, useState } from "react";
import { resolver } from "../../API/middlewares/resolveRequests";
import {
  getAllLookupByName,
  getAllLookupsNames,
} from "./../../API/services/utilities";
import LookupItem from "./lookupItem";
import Titlebar from "./../layout/titlebar";
import AdminHome from "../admin/adminHome";
import LookupsManage from "./lookupsManage";
import { ScrollToTop } from "../../algorithms";

const LookupsIndex = ({ userToken }) => {
  const [lookups, setLookups] = useState([]);
  const [selectedLookup, setSelectedLookup] = useState(null);
  useEffect(() => {
    resolver(getAllLookupsNames, setLookups);
    ScrollToTop();
  }, []);

  useEffect(() => {
    if (lookups?.data) setSelectedLookup(lookups?.data[0]);
  }, [lookups]);

  return (
    <div className="d-flex flex-column w-100">
      {/* title */}
      <Titlebar
        title={"الجداول الملحقة"}
        customImage={"/assets/images/Group 8313.png"}
        imgHeight={30}
        imgWidth={40}
        containerHeight={30}
        containerWidth={40}
      />
      <div className="d-flex flex-wrap col-lg-8 col-12 me-3 mt-4 justify-content-center justify-content-lg-start">
        {lookups?.data?.map((item, index) => {
          return (
            <LookupItem
              selectedLookup={selectedLookup}
              key={index}
              lookup={item}
              index={index}
              setSelectedLookup={setSelectedLookup}
            />
          );
        })}
      </div>
      <div>
        {selectedLookup && (
          <LookupsManage
            selectedLookup={selectedLookup}
            userToken={userToken}
          />
        )}
      </div>
    </div>
  );
};

export default LookupsIndex;
